/**
 * localState
 * 通过`localState`实现页面数据共享。
 * 每个页面都有独立的`state`，但整个APP只有一个`localState`
 * 需要共享数据的页面必须使用`localState`的接口（项目其他`action`都必须在`ready`之后执行）
 */

import deepSet from '../utils/deepSet';
import deepGet from '../utils/deepGet';

// 同步
const storage = window.localStorage;
const KEY = 'trip-local-state';
const localDB = {
  get() {
    let value = storage.getItem(KEY);
    try {
      value = JSON.parse(value);
    } catch (err) {}

    return value;
  },

  set(value) {
    if (typeof value !== 'string') {
      try {
        value = JSON.stringify(value);
      } catch (err) {
        value = null;
      }
    }

    return storage.setItem(KEY, value);
  }
};




/**
 * localState读写接口（同步）
 */
// 获取localStorage
export function get() {
  let state = localDB.get();
  return state ? state : undefined;
}

// 设置localState
export function set(state) {
  return localDB.set(state);
}


/**
 * 清空localState，或只清空某个属性
 * @param {*} key localState的key，如果为空则全部删除
 * * clear('entity');
 * * clear('trip.editing.tripEdit');
 * * clear();
 */
export function clear(key) {
  if (key) {
    let localState = get();
    deepSet(localState, key, undefined);
    localDB.set(localState);
  } else {
    return localDB.set(null);
  }
}



// 需要持久化的“子state”
export const PERSISTENT_STATE_KEYS = [
  'entity',
  'order.allOrders',
  'trip.allTrips',
  'trip.demo',
  'trip.detail',
  'trip.params',
  'trip.paramsCities',
  'region.selected',
  'trip.editing',
  'trip.selectedDay'
];


// 从state提取出localState
function extract(state) {
  let localState = {};

  PERSISTENT_STATE_KEYS.forEach(function (key) {
    deepSet(localState, key, deepGet(state, key));
  });

  return localState;
}


// actionType
export const actionType = '@RENDER_LOCAL_STATE';


// 等待actionType执行之后再执行callback
// 需要localState的页面都必须在ready之后才能执行其他action
export function ready(callback) {
  readyPromise
    .then(function (store) {
      let state = store.getState();
      callback(state);
      return state;
    });
}

// ready函数的辅助promise对象
let readyPromise = new Promise(function (resolve) {
  ready.status = 'pending';
  ready.resolve = function (store) {
    ready.status = 'resolved';
    resolve(store);
  };
});



/**
 * action
 * 用参数`state`替换当前页面的`state`。
 * 本接口被调用之后（即ready之后），当前页面的`state`会不断更新`localState`
 * @export
 * @param {object} state 当前页面的`state`，默认是`localState`
 * @returns Promise
 */
export function render(state) {
  return function (dispatch) {
    if (!state) {
      state = get();
    }

    dispatch({
      type: actionType,
      data: state
    });

    return Promise.resolve(state);
  };
}



// redux中间件，每次action都会执行
export function middleware(store) {
  return function (next) {
    return function (action) {
      next(action);
      if (action.type === actionType) {
        ready.resolve(store);
      }

      // 设置持久化数据
      if (ready.status === 'resolved') {

        let state = store.getState();
        let localState = extract(state);
        set(localState);
      }
    };
  };
}





// for test
window.localState = {get, set, clear};



// WEBPACK FOOTER //
// ./src/store/localState.js